import React, { useEffect, useState, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import * as bomAction from '../Bom/store/BOMConfig.action';
import * as action from '../store/DevelopmentOrder.action';
import * as submitAction from './Store/Submit.action';
import * as measurementAction from '../Measurment/Store/Measurement.action';
import { fetchDevorderSupplier } from '../PurchaseOrder/Store/PurchaseOrder.action';
import { createOptions, customStylesWhiteBordered, RightsAccess, generateColSizeLengthCombinations } from '../../../Components/helper';
import './SubmitDownload.css';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import SubmitPopupEmail from './SubmitPopupEmail';
import { getCreatedByUser } from '../../Dashboard/TodoList/PurchaseOrder/store/Purchase.action';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import * as colourAction from '../../Library/ColorLibary/store/ColorLibrary.action';
import { fetchMainProductDetails, fetchDppById } from '../DPPModule/store/DPPModule.action';
import { fetchSuppliersFactories } from '../../Library/BomLibrary/store/BomLibrary.action';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

const INTERNAL_SUPPLIER_ID = 'internal';
const INTERNAL_SUPPLIER_OPTION = { _id: INTERNAL_SUPPLIER_ID, value: INTERNAL_SUPPLIER_ID, label: 'Internal', name: 'Internal', email: '' };

function SubmitDownlod() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const { devOrderId } = useParams();
  const reducer = useSelector((reducer_state) => reducer_state);
  const { purchaseOrderData, Users, UserDetails, BOMConfigDetails, Measuremets, DPPProductReducer, SystemMastersDetails, ColorLibraryDetails } = reducer;
  const { supplierList } = purchaseOrderData;
  const { logInRights } = Users;
  const { productDetails } = BOMConfigDetails;
  const { customModuleMenu } = Measuremets;
  const { devProductData, dppProductDataById } = DPPProductReducer;
  const { ColorWaysLibList } = ColorLibraryDetails;
  const { identifierType, productIdentifierList, lengthsList } = SystemMastersDetails;
  const { CheckModulePermission } = useComponent();
  const {
    userInfo: { role, userId },
    isCompanyAdminLoggedIn,
  } = UserDetails;
  const { customModuleRight, purchaseOrderRight, TestingRight } = RightsAccess();
  const [lengthEnabled, setLengthEnabled] = useState(true);
  const [state, setState] = useState({
    loader: true,
    selectedSupplier: null,
    poOptions: [],
    sampleOptions: [],
    gradingOptions: [],
    pos: [],
    selectedModules: [],
    sampleType: [],
    customModule: [],
    customModuleOptions: [],
    isTechCombined: true,
    bomDocumentOptions: [],
    designDocumentOptions: [],
    colourDocumentOptions: [],
    pomDocumentOptions: [],
    otherDocumentOptions: [],
    poDocumentOptions: [],
    selectedgradingOptions: [],
    selectedbomDocumentOptions: [],
    selecteddesignDocumentOptions: [],
    selectedcolourDocumentOptions: [],
    selectedpomDocumentOptions: [],
    selectedotherDocumentOptions: [],
    selectedpoDocumentOptions: [],
    emailModal: false,
    bcc: '',
    cc: '',
    to: '',
    message: '',
    toErr: false,
    bccErr: false,
    ccErr: false,
    buttonLoader: false,
    userList: [],
    mainuserList: [],
    specificationGradGroup: [],
    pomImgsGradGroup: [],
    cadGradGroup: [],
    qrCodeOptions: [],
    selectedFactory: null,
    selectedqrCodeOptions: [],
    selectLabel: [],
    dppData: [],
    dppToggle: false,
    colourwayOptions: [],
    selectedColourway: null,
    selectedcustomModuleOptions: [],
    poOptionsLoaded: false,
  });
  const {
    selectedSupplier,
    poOptions,
    pos,
    selectedModules,
    sampleType,
    sampleOptions,
    customModuleOptions,
    gradingOptions,
    designDocumentOptions,
    bomDocumentOptions,
    pomDocumentOptions,
    otherDocumentOptions,
    colourDocumentOptions,
    poDocumentOptions,
    isTechCombined,
    selectedbomDocumentOptions,
    selecteddesignDocumentOptions,
    selectedcolourDocumentOptions,
    selectedpomDocumentOptions,
    selectedotherDocumentOptions,
    selectedpoDocumentOptions,
    selectedgradingOptions,
    emailModal,
    bcc,
    cc,
    to,
    message,
    buttonLoader,
    mainuserList,
    specificationGradGroup,
    qrCodeOptions,
    selectedcustomModuleOptions,
  } = state;
  const PurchaseOrderAccess = CheckModulePermission(logInRights, 'products', 'purchaseOrder', isCompanyAdminLoggedIn);
  const MeasurementAccess = CheckModulePermission(logInRights, 'products', 'measurement', isCompanyAdminLoggedIn);
  const customModuleAccess = CheckModulePermission(logInRights, 'products', 'customModule', isCompanyAdminLoggedIn);
  const SampleAccess = CheckModulePermission(logInRights, 'products', 'samples', isCompanyAdminLoggedIn);

  const obj = {
    'design-details': 'design',
    bom: 'bom',
    measurement: 'measurement',
    testing: 'testing',
    care: 'care',
    sample: 'sample',
    customModule: 'customModule',
  };

  const checkModalAccess = (name) => {
    const modules = ['design-details', 'bom', 'measurement', 'testing', 'care', 'sample'];
    const isModuleAccessible = modules.includes(name);

    const moduleKey = name === 'sample' ? 'samples' : obj[name];
    return isModuleAccessible ? CheckModulePermission(logInRights, 'products', moduleKey, isCompanyAdminLoggedIn) : true;
  };

  const otherObj = {
    pomImgs: 'measurement',
    document: 'measurement',
    pattern: 'measurement',
    'test-report': 'testing',
    'care-label-layout': 'care',
    bomDocument: 'bom',
    poDocuments: 'purchaseOrder',
    otherSpecificationDoc: 'measurement',
  };

  const checkOtherModalAccess = (name) => {
    if (name === 'customModule') {
      return customModuleAccess && customModuleRight;
    }
    return ['pomImgs', 'pattern', 'test-report', 'care-label-layout', 'bomDocument', 'document', 'poDocuments', 'otherSpecificationDoc'].includes(name)
      ? CheckModulePermission(logInRights, 'products', otherObj[name], isCompanyAdminLoggedIn)
      : true;
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (userData?.lengthVisible !== null && userData?.lengthVisible !== undefined) {
      setLengthEnabled(userData?.lengthVisible);
    }
  }, []);

  const subArray1 = [
    {
      type: 'designDocument',
      name: 'Design/Details Documents',
      type2: 'document',
      options: 'designDocumentOptions',
    },
    {
      type: 'colourDocument',
      name: 'Colour Documents',
      type2: 'document',
      options: 'colourDocumentOptions',
    },
    {
      type: 'bomDocument',
      name: 'BOM Documents',
      type2: 'document',
      options: 'bomDocumentOptions',
    },
    {
      type: 'otherSpecificationDoc',
      name: 'Specification Documents',
      type2: 'document',
      options: 'otherDocumentOptions',
    },
    {
      type: 'customModule',
      name: 'Custom Module Documents',
      type2: 'document',
      options: 'customModuleOptions',
    },
    {
      type: 'pomImgs',
      name: 'POM Guide',
      type2: 'document',
      options: 'gradingOptions',
    },
    {
      type: 'poDocuments',
      name: 'P.O. Documents',
      type2: 'document',
      options: 'poDocumentOptions',
    },
    {
      type: 'qrCode',
      name: 'QR Code',
      type2: 'document',
      options: 'qrCodeOptions',
    },

    { type: 'test-report', name: 'Testing Reports' },
    { type: 'care-label-layout', name: 'Care/User Instructions Layout' },
  ]?.filter((e) => checkOtherModalAccess(e?.type));

  const cpArray = ['po'];

  let tpArray = [];

  tpArray = ['design-details', 'bom', 'measurement', 'care', 'testing', 'sample']?.filter((ele) => checkModalAccess(ele));

  const subArray = [
    'designDocument',
    'pomImgs',
    'colourDocument',
    'qrCode',
    'test-report',
    'care-label-layout',
    'bomDocument',
    'poDocuments',
    'otherSpecificationDoc',
    'customModule',
  ]?.filter((e) => checkOtherModalAccess(e));
  const technicalPackageArray = TestingRight
    ? [
        { name: 'Design/Details', type: 'design-details' },
        { name: 'Bill of Materials (BOM)', type: 'bom' },
        { name: 'Measurements', type: 'measurement' },
        { name: 'Testing Requirements', type: 'testing' },
        { name: 'Care/User Instructions', type: 'care' },
      ]
    : [
        { name: 'Design/Details', type: 'design-details' },
        { name: 'Bill of Materials (BOM)', type: 'bom' },
        { name: 'Measurements', type: 'measurement' },
        { name: 'Care/User Instructions', type: 'care' },
      ];
  useEffect(() => {
    const callApi = async () => {
      const supplierIds = devProductData?.suppliers || [];
      await dispatch(fetchSuppliersFactories(supplierIds));
    };
    callApi();
  }, [devProductData?.suppliers, dispatch]);

  const factoryOptions = useMemo(
    () =>
      selectedSupplier && devProductData?.supplierFactories?.length > 0
        ? (selectedSupplier?.factories || [])
            .map((data) => {
              if (devProductData?.supplierFactories?.find((id) => data?._id === id)) {
                return { label: data?.factoryName, value: data?._id };
              }
              return undefined;
            })
            .filter(Boolean)
        : [],
    [selectedSupplier, devProductData?.supplierFactories],
  );

  useEffect(() => {
    if (factoryOptions.length > 0) {
      const selectData = { value: factoryOptions[0]?.value, label: factoryOptions[0]?.label };

      setState((prev) => ({
        ...prev,
        selectedFactory: selectData,
      }));
    }
  }, [factoryOptions]);

  const replaceAndFilterKeys = (object, mapping, includeKeys = []) => {
    return Object.keys(object).reduce((newObj, key) => {
      if (mapping[key] && includeKeys.includes(mapping[key])) {
        const newKey = mapping[key];
        newObj[newKey] = object[key];
      }
      return newObj;
    }, {});
  };

  const areAllFieldsBlank = (arr) => {
    return arr.every((obj) => Object.values(obj).every((value) => value === '' || value === undefined));
  };
  useEffect(() => {
    const callData = async () => {
      let createCombination = [];
      if (!identifierType && productIdentifierList.length > 0) {
        const sizeRanges = productDetails?.sizeRanges || [];
        const legLengths = lengthsList || [];
        const colourLibraries = ColorWaysLibList || [];
        createCombination = await generateColSizeLengthCombinations(sizeRanges, legLengths, colourLibraries);
        const sizeMasterId = productIdentifierList?.find((vl) => vl?.name === 'Size')?._id;
        const lengthMasterId = productIdentifierList?.find((vl) => vl?.name === 'Length')?._id;
        const colourMasterId = productIdentifierList?.find((vl) => vl?.name === 'Colourway')?._id;
        if (createCombination?.length !== productDetails?.productIndentifier?.length) {
          const keyMapping = {
            [colourMasterId]: 'colour',
            [sizeMasterId]: 'size',
            [lengthMasterId]: 'length',
          };
          let includeKeys = null;
          if (dppProductDataById?.colorwayToggel === true && dppProductDataById?.sizeLengthToggel === true) {
            includeKeys = ['colour', 'size', 'length'];
          } else if (dppProductDataById?.colorwayToggel === true && dppProductDataById?.sizeLengthToggel === false) {
            includeKeys = ['colour'];
          } else if (dppProductDataById?.colorwayToggel === false && dppProductDataById?.sizeLengthToggel === true) {
            includeKeys = ['size', 'length'];
          } else {
            includeKeys = [];
          }
          createCombination = productDetails?.productIndentifier?.map((item) => replaceAndFilterKeys(item, keyMapping, includeKeys));
        }
      } else {
        const sizeRanges = productDetails?.sizeRanges || [];
        const legLengths = productDetails?.legLengths || [];
        const colourLibraries = productDetails?.colourLibraries || [];
        createCombination = await generateColSizeLengthCombinations(sizeRanges, legLengths, colourLibraries);
      }
      let newCreateCombination = [];
      if (
        createCombination?.length > 0 &&
        !areAllFieldsBlank(createCombination) &&
        (dppProductDataById.colorwayToggel || dppProductDataById.sizeLengthToggel)
      ) {
        newCreateCombination = createCombination.map((item, index) => {
          const colour = ColorWaysLibList?.filter((test) => test?._id === item?.colour)?.map((k) => k?.name)[0];
          const length = lengthEnabled ? lengthsList?.filter((test) => test?._id === item?.length)?.map((k) => k?.name)[0] : '';

          const parts = [item?.size, length, colour].filter(Boolean);
          return {
            label: parts.join(', '),
            value: parts.join('-'),
            _id: index,
          };
        });

        setState((prev) => ({
          ...prev,
          qrCodeOptions: newCreateCombination,
          dppToggle: true,
        }));
      } else if (
        createCombination.length > 0 &&
        !areAllFieldsBlank(createCombination) &&
        !dppProductDataById.colorwayToggel &&
        !dppProductDataById.sizeLengthToggel
      ) {
        const options = state.dppData?.filter((item) => item?.dppName === dppProductDataById?.dppName);
        const dppDocuments = createOptions(options, 'dppName', '_id');
        setState((prev) => ({
          ...prev,
          qrCodeOptions: dppDocuments,
          dppToggle: false,
        }));
      } else if (areAllFieldsBlank(createCombination)) {
        const options = state.dppData?.filter((item) => item?.dppName === dppProductDataById?.dppName);
        const dppDocuments = createOptions(options, 'dppName', '_id');
        setState((prev) => ({
          ...prev,
          qrCodeOptions: dppDocuments,
          dppToggle: false,
        }));
      }
    };
    if (productDetails && Object.keys(productDetails).length > 0 && ColorWaysLibList && lengthsList) {
      callData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDetails, productIdentifierList, ColorWaysLibList, lengthsList, dppProductDataById, state.dppData]);

  const initialExicution = async () => {
    const supplierIds = devProductData?.suppliers || [];
    await dispatch(fetchSuppliersFactories(supplierIds));
    const obj = {
      devOrderId,
      allDetails: true,
    };
    await Promise.all([
      dispatch(bomAction.fetchProductDetails(devOrderId)),
      dispatch(bomAction.fetchTrafficLights(devOrderId)),
      dispatch(action.getDesignDetail(devOrderId)),
      dispatch(fetchDevorderSupplier(obj)),
      dispatch(fetchMainProductDetails(devOrderId)),
      dispatch(systemMasterAction.fetchProductIdentifierType(t)),
      dispatch(systemMasterAction.fetchProductIdentifier(t)),
      dispatch(colourAction.fetchColorListLibrary({ loggedInUserId: userId })),
      dispatch(systemMasterAction.getLengthsDetails({ isActive: true, loggedInUserId: userId })),
    ]);

    const measurObj = {
      id: devOrderId,
      obj: {
        isDropDown: true,
      },
    };
    const designRes = await dispatch(action.getSupportingDesignDetails(devOrderId));
    const pomRes = await dispatch(submitAction.getMeasurementDocuments(measurObj));
    const otherRes = await dispatch(measurementAction.getAllActiveDocuments(devOrderId)); // after new change
    const poRes = purchaseOrderRight ? await dispatch(submitAction.getPoDocuments(measurObj)) : [];
    const bomRes = await dispatch(submitAction.getBOMSUDocuments(measurObj));
    const dppDataset = await dispatch(action.getdppModuleList({ devOrderId }));
    if (dppDataset && dppDataset?.length > 0) {
      await dispatch(fetchDppById(devOrderId, dppDataset[0]?._id));
    }
    let BOMDocuments = [];
    let ColourDocuments = [];
    let POMDocuments = [];
    let PODocuments = [];
    let OTHERDocuments = [];
    let designSupportDocs = [];
    if (bomRes && bomRes.length > 0) {
      const modifiedArray = bomRes.map((dat) => {
        const mDate = moment(dat.createdAt).format('DD-MMMM-YYYY, HH:mm');
        dat.label = `${dat.fileName} ${mDate}`;
        dat.value = dat?._id;
        return dat;
      });

      BOMDocuments = modifiedArray ? modifiedArray.filter((i) => !i.docType || i.docType === 'Quality') : [];

      ColourDocuments = modifiedArray ? modifiedArray.filter((i) => i.docType === 'Colour') : [];
    }
    if (pomRes && pomRes.length > 0) {
      POMDocuments = createOptions(pomRes, 'fileName', '_id');
    }
    if (otherRes && otherRes?.data?.length > 0) {
      OTHERDocuments = createOptions(otherRes?.data, 'documentTitle', '_id');
    }
    if (poRes && poRes.length > 0) {
      PODocuments = createOptions(poRes, 'fileName', '_id');
    }
    if (designRes?.data?.length > 0) {
      const visibleSupplierDocs = designRes?.data?.filter((doc) => doc.isVisibleToSupplier === true);
      if (visibleSupplierDocs.length > 0) {
        designSupportDocs = createOptions(visibleSupplierDocs, 'documentName', '_id');
      }
    }

    setState((prev) => ({
      ...prev,
      loader: false,
      bomDocumentOptions: BOMDocuments,
      colourDocumentOptions: ColourDocuments,
      poDocumentOptions: PODocuments,
      otherDocumentOptions: OTHERDocuments,
      pomDocumentOptions: POMDocuments,
      designDocumentOptions: designSupportDocs,
      dppData: dppDataset,
    }));
  };

  useEffect(() => {
    initialExicution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dppProductDataById) {
      let dppDocuments = [];
      const options = state.dppData?.filter((item) => item?.dppName === dppProductDataById?.dppName);
      if (state.dppData && state.dppData?.length > 0 && !dppProductDataById.colorwayToggel && !dppProductDataById.sizeLengthToggel) {
        dppDocuments = createOptions(options, 'dppName', '_id');
        setState((prev) => ({
          ...prev,
          qrCodeOptions: dppDocuments,
          dppToggle: false,
        }));
      }
    }
  }, [dppProductDataById, state.dppData]);

  useEffect(() => {
    productDetails?.gradingGroups?.map((ele) => {
      ele._id = ele.value;
      return ele;
    });
    setState((prev) => ({
      ...prev,
      gradingOptions: productDetails?.gradingGroups || [],
    }));
  }, [productDetails]);

  useEffect(() => {
    const init = async () => {
      const isInternal = selectedSupplier?._id === INTERNAL_SUPPLIER_ID;
      let sampleOptionsforLabel = [];
      const res1 = await dispatch(action.getOrderSamples(devOrderId));
      if (res1?.code === 200) {
        const sampleOptionsOfSupp = res1?.data?.filter((sam) => sam?.supplier === selectedSupplier?._id);
        sampleOptionsforLabel = createOptions(sampleOptionsOfSupp, 'sampleNumber', '_id');
        sampleOptionsforLabel.map((opt) => {
          const sampleDate = moment(opt.createdAt).format('DD-MMMM-YYYY, HH:mm');
          const sampleTypeName = opt.sampleType ? ` - ${opt.sampleType}` : '';
          const newLabel = `${opt.label}${sampleTypeName} ${sampleDate}`;
          opt.label = newLabel;
          return opt;
        });
      }

      const userList = await dispatch(
        getCreatedByUser({
          CompanyUsers: true,
          adminUsers: true,
          supplierId: isInternal ? undefined : selectedSupplier?._id,
        }),
      );
      let userList1 = [];
      if (Array.isArray(userList)) {
        userList1 = userList.map((val) => {
          return {
            id: val.email,
            name: `${val.firstName} ${val.lastName}`,
            // image: val["image"],
            display: `${val.email}, `,
            label: val.email,
          };
        });
      }

      const queryObj = {
        brand: productDetails?.brandId,
        catOne: productDetails?.catOneId?._id,
        catTwo: productDetails?.catTwoId?._id,
        supplierId: selectedSupplier?._id,
        companyUserSubmitDownload: true,
      };

      const supplierUserList = isInternal ? [] : await dispatch(submitAction.getsupplierUser(queryObj));
      let ccMail = [];
      if (supplierUserList) {
        ccMail = supplierUserList.length ? supplierUserList.map((val) => val.email) : [];
      }
      const toMail = !isInternal && selectedSupplier?.email ? `${selectedSupplier?.email}, ` : '';
      setState((prev) => ({
        ...prev,
        sampleOptions: sampleOptionsforLabel,
        sampleType: [],
        selectedModules: (prev.selectedModules || []).filter((module) => module !== 'sample'),
        to: toMail,
        cc: isInternal ? '' : ccMail.join(', '),
        userList: userList1,
        mainuserList: userList1,
      }));
      const param = { devOrderId, isActive: true };
      await dispatch(action.getCustomModuleList(param));
      // ✅ FIXED: Fetch PO options immediately when supplier is selected
      // Preserve colourway selection and let API filter appropriately
      if (selectedSupplier) {
        await fetchPOOptions(state.selectedColourway); // Use existing colourway filter if any
      }
    };

    init();
    setState((prev) => ({ ...prev, poOptionsLoaded: false }));
  }, [selectedSupplier]);

  useEffect(() => {
    if (customModuleMenu) {
      const cmOptions = customModuleMenu?.map((ele) => {
        const eleCopy = { ...ele };
        eleCopy.label = ele.moduleName;
        eleCopy.value = ele._id;
        return eleCopy;
      });
      setState((prev) => ({
        ...prev,
        customModuleOptions: cmOptions,
      }));
    }
  }, [customModuleMenu]);

  useEffect(() => {
    const arr = [...to.split(', '), ...bcc.split(', '), ...cc.split(', ')];
    const newUserList = [];
    mainuserList?.forEach((user) => {
      if (!arr.includes(user?.label)) {
        newUserList.push(user);
      }
    });
    setState((prev) => ({
      ...prev,
      userList: newUserList,
    }));
  }, [to, bcc, cc]);

  const handleSelectChange = (value, field) => {
    setState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const valueChange = (value, array, selectedModules1, section) => {
    if (value) {
      array.forEach((model) => {
        if (selectedModules1.indexOf(model) === -1) {
          selectedModules1.push(model);
          if (model === 'sample' && sampleOptions.length === 1) {
            handleSelectChange([sampleOptions[0].value], 'sampleType');
          }
          if (model === 'customModule' && customModuleOptions.length === 1) {
            handleSelectChange([customModuleOptions[0].value], 'customModule');
          }
          if (model === 'measurement' && gradingOptions.length === 1) {
            handleSelectChange([gradingOptions[0].value], 'specificationGradGroup');
          }
          if (model === 'designDocument' && state.designDocumentOptions.length === 1 && section === 'sub') {
            handleSelectChange([designDocumentOptions[0].value], 'selecteddesignDocumentOptions');
          }
          if (model === 'bomDocument' && bomDocumentOptions.length === 1 && section === 'sub') {
            handleSelectChange([bomDocumentOptions[0].value], 'selectedbomDocumentOptions');
          }
          if (model === 'colourDocument' && colourDocumentOptions.length === 1 && section === 'sub') {
            handleSelectChange([colourDocumentOptions[0].value], 'selectedcolourDocumentOptions');
          }
          if (model === 'otherSpecificationDoc' && otherDocumentOptions.length === 1 && section === 'sub') {
            handleSelectChange([otherDocumentOptions[0].value], 'selectedotherDocumentOptions');
          }
          if (model === 'pomImgs' && gradingOptions.length === 1 && section === 'sub') {
            handleSelectChange([gradingOptions[0].value], 'selectedgradingOptions');
          }
          if (model === 'poDocuments' && poDocumentOptions.length === 1 && section === 'sub') {
            handleSelectChange([poDocumentOptions[0].value], 'selectedpoDocumentOptions');
          }
          if (model === 'pomDocument' && pomDocumentOptions.length === 1) {
            handleSelectChange([pomDocumentOptions[0].value], 'selectedpomDocumentOptions');
          }
          if (model === 'qrCode' && qrCodeOptions.length === 1 && state.dppToggle) {
            handleSelectChange([qrCodeOptions[0].value], 'selectedqrCodeOptions');
          } else if (model === 'qrCode' && qrCodeOptions.length === 1 && !state.dppToggle) {
            setState((prev) => ({
              ...prev,
              selectLabel: [qrCodeOptions[0].label],
            }));
          }
          // ✅ FIXED: Select all available PO options when "Select All" is clicked for PO
          if (model === 'po') {
            // Ensure PO options are loaded before selecting all
            if (!state.poOptionsLoaded && selectedSupplier) {
              fetchPOOptions(state.selectedColourway || null).then(() => {
                // After PO options are loaded, select all available POs
                if (poOptions.length > 0) {
                  const allPOValues = poOptions.map((option) => option.value);
                  handleSelectChange(allPOValues, 'pos');
                }
              });
            } else if (poOptions.length > 0) {
              // If PO options are already loaded, select all
              const allPOValues = poOptions.map((option) => option.value);
              handleSelectChange(allPOValues, 'pos');
            }
          }
        }
      });
    } else {
      array.forEach((model) => {
        selectedModules1.splice(selectedModules1.indexOf(model), 1);
        // ✅ FIXED: Clear PO selections when unchecking "Select All"
        if (model === 'po') {
          handleSelectChange([], 'pos');
        }
      });
    }
  };

  function handleSelectAll(section, value) {
    const selectedModules1 = selectedModules;
    if (section === 'cp') {
      valueChange(value, cpArray, selectedModules1, section);
    } else if (section === 'sub') {
      valueChange(value, subArray, selectedModules1, section);
    } else {
      valueChange(value, tpArray, selectedModules1, section);
    }
    setState((prev) => ({
      ...prev,
      selectedModules: selectedModules1,
    }));
  }

  function handleSelect(field, options) {
    const checkGradingGroupLen = gradingOptions.length;
    // to default select of grading group for specification and POM guide when only 1 data present
    if (field === 'measurement') {
      if (checkGradingGroupLen === 1) {
        handleSelectChange([gradingOptions[0].value], 'specificationGradGroup');
      }
    }
    if (field === 'pomImgs') {
      if (checkGradingGroupLen === 1) {
        handleSelectChange([gradingOptions[0].value], 'selectedgradingOptions');
      }
    }

    if (field === 'customModule') {
      if (customModuleOptions.length === 1) {
        handleSelectChange([customModuleOptions[0].value], 'customModule');
      }
    }
    if (field === 'sample') {
      if (sampleOptions.length === 1) {
        handleSelectChange([sampleOptions[0].value], 'sampleType');
      }
    }
    // ✅ IMPROVED: Enhanced auto-selection logic for PO options
    if (field === 'po') {
      if (poOptions.length === 1) {
        // Auto-select single PO option
        handleSelectChange([poOptions[0].value], 'pos');
      } else if (poOptions.length === 0 && selectedSupplier && !state.poOptionsLoaded) {
        // If no PO options loaded yet, fetch them first
        fetchPOOptions(state.selectedColourway || null).then(() => {
          if (poOptions.length === 1) {
            handleSelectChange([poOptions[0].value], 'pos');
          }
        });
      }
    }
    if (field === 'qrCode' && qrCodeOptions.length === 1 && state.dppToggle) {
      handleSelectChange([qrCodeOptions[0].value], 'selectedqrCodeOptions');
    } else if (field === 'qrCode' && qrCodeOptions.length === 1 && !state.dppToggle) {
      setState((prev) => ({
        ...prev,
        selectLabel: [qrCodeOptions[0].label],
      }));
    }
    if (state[options]?.length === 1) {
      handleSelectChange([state[options][0].value], `selected${options}`);
    }

    const selectedModules1 = selectedModules;
    if (selectedModules1.indexOf(field) > -1) selectedModules1.splice(selectedModules1.indexOf(field), 1);
    else {
      selectedModules1.push(field);
    }
    setState((prev) => ({
      ...prev,
      selectedModules: selectedModules1,
    }));
  }

  const toggleEmailModal = () => {
    setState((prev) => ({
      ...prev,
      emailModal: !prev.emailModal,
    }));
  };

  const checkIsChecked = (field) => {
    let count = 0;
    field.forEach((sel) => {
      if (selectedModules.includes(sel)) {
        count++;
      }
    });
    return count === field.length;
  };

  const customValueRenderer = (selected, _options, val) => {
    // to add label
    if (!selected || selected?.length === 0) {
      return val;
    }
    if (selected?.length === _options?.length) {
      return 'All Items are selected';
    }
    return selected.length ? selected.map(({ label }) => label).join(', ') : val;
  };

  function validateEmail(email) {
    const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
    return re.test(String(email).toLowerCase()) > 0;
  }

  const mailCheck = (array) => {
    return array.length === 0;
  };

  const submitValidation = () => {
    let ccMailErr = false;
    let showToVaildErr = false;
    let bccMailErr = false;
    let mailArray = to ? to.split(',') : [];
    let ccMailarray = cc ? cc.split(',') : [];
    let bccMailarray = bcc ? bcc.split(',') : [];
    mailArray = mailArray.filter((val) => val !== '' && val !== ' ');

    ccMailarray = ccMailarray.filter((val) => val !== '' && val !== ' ');
    bccMailarray = bccMailarray.filter((val) => val !== '' && val !== ' ');
    showToVaildErr = mailCheck(mailArray);
    mailArray = mailArray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        showToVaildErr = true;
      }
      return val;
    });
    ccMailarray = ccMailarray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        ccMailErr = true;
      }
      return val;
    });
    bccMailarray = bccMailarray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        bccMailErr = true;
      }
      return val;
    });

    setState((prev) => ({
      ...prev,
      toErr: showToVaildErr,
      ccErr: ccMailErr,
      bccErr: bccMailErr,
    }));
    if (!showToVaildErr && !ccMailErr && !bccMailErr) {
      return {
        mailArray,
        ccMailarray,
        bccMailarray,
      };
    }
    return false;
  };
  const getTpAndSelectedVal = () => {
    let tpArray1 = [];
    let selectedModules1 = [];
    if (isTechCombined) {
      tpArray1 = tpArray?.filter((val) => selectedModules.indexOf(val) > -1);
      if (tpArray1?.length > 0) tpArray1.unshift('dev-order');
      selectedModules1 = selectedModules?.filter((val) => tpArray1?.indexOf(val) === -1);
    } else {
      selectedModules1 = selectedModules;
    }
    return { tpArray1, selectedModules1 };
  };

  // ✅ FIXED: Helper function to reset all selections after successful submit/download
  const resetAllSelections = () => {
    setState((prev) => ({
      ...prev,
      selectedModules: [],
      pos: [],
      sampleType: [],
      selectedcustomModuleOptions: [],
      specificationGradGroup: [],
      selectedgradingOptions: [],
      selectedbomDocumentOptions: [],
      selecteddesignDocumentOptions: [],
      selectedcolourDocumentOptions: [],
      selectedpomDocumentOptions: [],
      selectedotherDocumentOptions: [],
      selectedpoDocumentOptions: [],
      selectedqrCodeOptions: [],
      selectLabel: [],
      cc: '',
      bcc: '',
      message: '',
      emailModal: false,
    }));
  };
  const downloadSubmitTechpack = async (type) => {
    if (selectedModules?.length > 0 || type === 'submit') {
      if (!selectedSupplier) {
        toasterMsg(t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.PLEASE_SELECT_SUPLIER'), 'danger');
        return;
      }

      if (selectedModules?.indexOf('measurement') > -1 && specificationGradGroup.length === 0) {
        toasterMsg(t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.GRADING_GROUP_SPECIFICATION'), 'danger');
        return;
      }

      if (selectedModules?.indexOf('customModule') > -1 && selectedcustomModuleOptions?.length === 0) {
        toasterMsg(t('SUBMIT_DOWNLOAD.CUSTOM_MODULE_REQUITED'), 'danger');
        return;
      }

      if (selectedModules?.indexOf('pomImgs') > -1 && selectedgradingOptions?.length === 0) {
        toasterMsg(t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.GRADING_GROUP_POM_MESSAGE'), 'danger');
        return;
      }
      let urls = [];
      if (selectedModules?.indexOf('qrCode') > -1 && state?.selectedqrCodeOptions?.length > 0 && state?.dppToggle) {
        const formattedStrings = state?.selectedqrCodeOptions.map((str) => str.replace(/-/g, ' - '));
        urls = dppProductDataById?.publishUrl
          ?.map((val) => {
            if (val?.isNew && formattedStrings?.includes(val?.variant)) {
              return val;
            }
            return val;
          })
          .filter(Boolean);
      } else if (selectedModules?.indexOf('qrCode') > -1 && state?.selectLabel?.length > 0 && !state?.dppToggle) {
        urls = dppProductDataById?.publishUrl;
      }
      const { tpArray1, selectedModules1 } = getTpAndSelectedVal();
      const obj = {
        selectedModules: JSON.stringify(selectedModules1),
        supplier: selectedSupplier?._id,
        timeZone,
        designDocument: JSON.stringify(selecteddesignDocumentOptions),
        bomDocuments: JSON.stringify(selectedbomDocumentOptions),
        colourDocuments: JSON.stringify(selectedcolourDocumentOptions),
        otherDocuments: JSON.stringify(selectedotherDocumentOptions),
        poDocuments: JSON.stringify(selectedpoDocumentOptions),
        sampleType: JSON.stringify(sampleType),
        customModule: selectedcustomModuleOptions,
        specificationGradGroup,
        pomImgsGradGroup: selectedgradingOptions,
        pos,
        devOrderId,
        documents: JSON.stringify(selectedpomDocumentOptions),
        isTechCombined,
        tpArray: tpArray1,
        qrCode: state.dppToggle ? JSON.stringify(state?.selectedqrCodeOptions) : JSON.stringify(state?.selectLabel),
        factoryData: JSON.stringify(state.selectedFactory),
        publishUrl: urls,
        colourway: state.selectedColourway,
        lengthEnabled,
      };
      if (type === 'download') {
        setState((prev) => ({
          ...prev,
          buttonLoader: true,
        }));
        /* The server accepts the request and answers straight away; the archive itself arrives
        over `submit-download-ready`, which socket.js turns into the download. The button is
        therefore released as soon as the request is accepted rather than held for the whole
        render, which on a multi-product techpack used to outlast the request timeout. */
        const downloadResult = await dispatch(submitAction.requestOrderSubmitDownload(obj, t));
        setState((prev) => ({
          ...prev,
          buttonLoader: false,
        }));
        if (downloadResult && downloadResult !== false) {
          resetAllSelections();
          toasterMsg(t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.DOWNLOAD_PREPARING'), 'success');
        }
      } else {
        const submitObj = submitValidation();
        if (submitObj) {
          setState((prev) => ({
            ...prev,
            loader: true,
          }));
          const newObj = {
            ...obj,
            to: submitObj.mailArray,
            bcc: submitObj.bccMailarray,
            cc: submitObj.ccMailarray,
            message,
          };
          const res = await dispatch(submitAction.sendSupplierEmail(newObj, t));
          if (res === 200) {
            resetAllSelections();
          }
          setState((prev) => ({
            ...prev,
            loader: false,
          }));
        }
      }
    } else {
      toasterMsg(t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.PLEASE_SELECT_AT_LEAST_MODULE'), 'danger');
    }
  };

  const fetchPOOptions = async (colourwaySelection = null) => {
    if (!selectedSupplier) return;

    try {
      // Build filter object with supplier and optional colourway
      const poFilterObj = {
        isSubmit: true,
        devOrderId,
        supplier: selectedSupplier?._id,
      };

      // Add colourway filter if provided
      if (colourwaySelection && colourwaySelection.length > 0) {
        poFilterObj.colourway = colourwaySelection;
      }

      const res = await dispatch(submitAction.getFilteredPOs(poFilterObj));
      const filteredPOs = res || [];
      const poOptionsArray = createOptions(filteredPOs, 'purchaseOrderNumber', '_id');

      setState((prev) => ({
        ...prev,
        poOptions: poOptionsArray,
        poOptionsLoaded: true,
      }));
    } catch (error) {
      console.error('Error fetching PO options:', error);
      setState((prev) => ({
        ...prev,
        poOptions: [],
        poOptionsLoaded: false,
      }));
    }
  };

  const costingAndPurchasing = () => {
    return (
      <div className="col-md-4 mb-2 mb-md-0">
        <div className="listing-card card h-100 mb-16">
          <div className="card-header">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.COSTING_PURCHASING')}</div>
          {PurchaseOrderAccess && (
            <div className="card-body">
              <div className="form-group">
                <div className="common-checkbox size-sm">
                  <input
                    id="cp-all"
                    type="checkbox"
                    checked={checkIsChecked(cpArray)}
                    onChange={(e) => handleSelectAll('cp', e.target.checked)}
                    disabled={productDetails?.isArchived}
                  />
                  <label htmlFor="cp-all" className="chklabel">
                    <span className="f-16 font-medium">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SELECT_ALL')}</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <div className="m-control-outer user-right-popup d-flex align-items-center">
                  <div className="common-checkbox size-sm">
                    <input
                      id="po"
                      type="checkbox"
                      checked={selectedModules?.indexOf('po') > -1}
                      onChange={() => handleSelect('po')}
                      disabled={productDetails?.isArchived}
                    />
                    <label htmlFor="po" className="chklabel" />
                  </div>
                  <div className="multiselect-box po-select p-relative flex-fill ml-10">
                    <MultiSelect
                      name="group"
                      options={state.poOptions}
                      className="product-custom-multiselect common-new-multiselect w-100"
                      disabled={productDetails?.isArchived}
                      value={state.poOptions?.filter((val) => pos?.includes(val.value))}
                      labelledBy={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.PURCHASE_ORDERS')}
                      onChange={(selected) => handleSelectChange(selected ? selected.map((val) => val.value) : [], 'pos')}
                      valueRenderer={(selected, _options) =>
                        customValueRenderer(selected, _options, t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.PURCHASE_ORDERS'))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const getFilteredOptions = (tech) => {
    const baseOptions = state[tech.options];

    if (!baseOptions || isEmpty(baseOptions)) {
      return [];
    }
    if (tech.type === 'qrCode') {
      return baseOptions.filter((val) => state?.selectedqrCodeOptions?.includes(val?.value));
    }

    const selectedOptionsKey = `selected${tech.options}`;
    // Options created via createOptions carry `value`, not `_id`
    return baseOptions.filter((val) => state?.[selectedOptionsKey]?.includes(val?.value));
  };

  const otherPackage = () => {
    return (
      <div className="col-md-4">
        <div className="listing-card card h-100 mb-16">
          <div className="card-header">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.OTHER')}</div>
          <div className="card-body">
            <div className="form-group">
              <div className="common-checkbox size-sm">
                <input
                  id="sub-all"
                  type="checkbox"
                  checked={checkIsChecked(subArray)}
                  onChange={(e) => handleSelectAll('sub', e.target.checked)}
                  disabled={productDetails?.isArchived}
                />
                <label htmlFor="sub-all" className="chklabel">
                  <span className="f-16 font-medium">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SELECT_ALL')}</span>
                </label>
              </div>
            </div>
            {subArray1.map((tech, idx) => {
              return tech.type2 ? (
                checkOtherModalAccess(tech?.type) && (
                  <div className="form-group" key={tech?.type}>
                    <div className="m-control-outer user-right-popup d-flex align-items-center">
                      <div className="common-checkbox size-sm">
                        <input
                          id={`other${idx}`}
                          disabled={
                            (tech?.type === 'qrCode' ? dppProductDataById?.publishUrl?.length === 0 || dppProductDataById?.publishUrl === undefined : false) ||
                            productDetails?.isArchived
                          }
                          type="checkbox"
                          checked={selectedModules?.indexOf(tech.type) > -1}
                          onChange={() => handleSelect(tech.type, tech.options)}
                        />
                        <label htmlFor={`other${idx}`} className="chklabel" />
                      </div>
                      <div className="multiselect-box po-select p-relative flex-fill ml-10">
                        <MultiSelect
                          name="group"
                          options={state[tech.options]}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={getFilteredOptions(tech)}
                          disabled={
                            (tech?.type === 'qrCode' ? dppProductDataById?.publishUrl?.length === 0 || dppProductDataById?.publishUrl === undefined : false) ||
                            productDetails?.isArchived
                          }
                          labelledBy={tech.name}
                          onChange={(selected) => {
                            if (tech?.type === 'qrCode' && !state.dppToggle) {
                              setState((prev) => ({
                                ...prev,
                                selectLabel: selected.map((val) => val.label),
                              }));
                            }

                            // Use `.value` for createOptions-based lists (poDocuments, designDocument, bomDocument, document, otherSpecificationDoc)
                            const mapped = selected.map((val) => val.value);
                            handleSelectChange(mapped, `selected${tech.options}`);
                          }}
                          valueRenderer={(selected, _options) => customValueRenderer(selected, _options, tech.name)}
                        />
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <div className="form-group" key={tech.type}>
                  <div className="common-checkbox size-sm">
                    <input
                      id={`other${idx}`}
                      type="checkbox"
                      checked={selectedModules?.indexOf(tech.type) > -1}
                      onChange={() => handleSelect(tech.type)}
                      disabled={productDetails?.isArchived}
                    />
                    <label htmlFor={`other${idx}`} className="chklabel">
                      <span className="f-16 font-medium">{tech.name}</span>
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  const technicalPackage = () => {
    return (
      <div className="col-md-4 mb-2 mb-md-0">
        <div className="listing-card card h-100 mb-16">
          <div className="card-header">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.TECHNICAL_PACKAGE')}</div>
          <div className="card-body">
            <div className="form-group">
              <div className="common-checkbox size-sm">
                <input
                  id="tp-all"
                  type="checkbox"
                  checked={checkIsChecked(tpArray)}
                  onChange={(e) => handleSelectAll('tp', e.target.checked)}
                  disabled={productDetails?.isArchived}
                />
                <label htmlFor="tp-all" className="chklabel">
                  <span className="f-16 font-medium">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SELECT_ALLS')}</span>
                </label>
              </div>
            </div>
            {technicalPackageArray.map((tech, idx) => (
              <>
                {tech.type !== 'measurement' && checkModalAccess(tech?.type) && (
                  <div className="form-group" key={tech?.type}>
                    <div className="common-checkbox size-sm">
                      <input
                        id={`tech${idx}`}
                        type="checkbox"
                        checked={selectedModules?.indexOf(tech.type) > -1}
                        onChange={() => handleSelect(tech.type)}
                        disabled={productDetails?.isArchived}
                      />
                      <label htmlFor={`tech${idx}`} className="chklabel">
                        <span className="f-16 font-medium">{tech.name}</span>
                      </label>
                    </div>
                  </div>
                )}

                {tech.type === 'measurement' && MeasurementAccess && (
                  <div className="form-group">
                    <div className="m-control-outer user-right-popup d-flex align-items-center">
                      <div className="common-checkbox size-sm">
                        <input
                          id="measurements"
                          type="checkbox"
                          checked={selectedModules?.indexOf('measurement') > -1}
                          onChange={() => handleSelect('measurement')}
                          disabled={productDetails?.isArchived}
                        />
                        <label htmlFor="measurements" className="chklabel" />
                      </div>
                      <div className="multiselect-box po-select p-relative flex-fill ml-10">
                        <MultiSelect
                          name="label"
                          options={gradingOptions || []}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          disabled={productDetails?.isArchived}
                          value={
                            gradingOptions?.length > 0 &&
                            gradingOptions?.filter(
                              (val) => !isEmpty(gradingOptions) && specificationGradGroup.length && specificationGradGroup?.includes(val?.value),
                            )
                          }
                          labelledBy={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SPECIFICATIONS')}
                          onChange={(selected) => {
                            handleSelectChange(
                              selected.map((val) => val.value),
                              'specificationGradGroup',
                            );
                          }}
                          valueRenderer={(selected, _options) => customValueRenderer(selected, _options, 'Specification(s)')}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            ))}

            {SampleAccess && (
              <div className="form-group">
                <div className="m-control-outer user-right-popup d-flex align-items-center">
                  <div className="common-checkbox size-sm">
                    <input
                      id="sample"
                      type="checkbox"
                      checked={selectedModules?.indexOf('sample') > -1}
                      onChange={() => handleSelect('sample')}
                      disabled={productDetails?.isArchived}
                    />
                    <label htmlFor="sample" className="chklabel" />
                  </div>
                  <div className="multiselect-box po-select p-relative flex-fill ml-10">
                    <MultiSelect
                      name="group"
                      options={sampleOptions}
                      className="product-custom-multiselect common-new-multiselect w-100"
                      disabled={productDetails?.isArchived}
                      value={sampleOptions?.filter((val) => !isEmpty(sampleOptions) && sampleType?.includes(val?._id))}
                      labelledBy={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SAMPLES')}
                      onChange={(selected) => {
                        handleSelectChange(
                          selected.map((val) => val._id),
                          'sampleType',
                        );
                      }}
                      valueRenderer={(selected, _options) => customValueRenderer(selected, _options, 'Sample(s)')}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="form-group">
              <span>
                <label htmlFor="document" className="asterisk-req">
                  {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.PACKAGE_DOCUMENT')} <span className="p-0">*</span>
                </label>{' '}
                <div className="d-flex align-items-center">
                  <p className="custom-radio mb-0 mr-3">
                    <input
                      type="radio"
                      id="detailed_yes"
                      name="detailed_yes"
                      checked={isTechCombined}
                      onChange={() => {
                        handleSelectChange(true, 'isTechCombined');
                      }}
                    />
                    <label className="m-0" htmlFor="detailed_yes">
                      {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.YES')}
                    </label>
                  </p>
                  <p className="custom-radio mb-0 mr-3">
                    <input
                      type="radio"
                      id="detailed_no"
                      name="detailed_no"
                      checked={!isTechCombined}
                      disabled={productDetails?.isArchived}
                      onChange={() => {
                        handleSelectChange(false, 'isTechCombined');
                      }}
                    />
                    <label className="m-0" htmlFor="detailed_no">
                      {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.NO')}
                    </label>
                  </p>
                </div>
              </span>
            </div>
          </div>
        </div>{' '}
      </div>
    );
  };

  const displayButtons = () => {
    let submitDisabled = true;
    let downloadDisabled = true;
    if (role !== 'Admin') {
      logInRights?.forEach((log) => {
        submitDisabled = log?.submitTechPack;
        downloadDisabled = log?.downloadTechPack;
      });
    }

    return (
      <div className="floting-actions">
        {!productDetails?.isArchived && (
          <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.LOG')}>
            <Link className="cursor-pointer text-dark text-decoration-none btn p-0 " to={`/development-order/${devOrderId}/submit-download-logs`}>
              <i className="icon-Preview-Log" />
            </Link>
          </CustomTooltip>
        )}

        {downloadDisabled && (
          <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.DOWNLOAD')}>
            <button
              className="btn p-0"
              aria-label="button"
              type="button"
              onClick={() => downloadSubmitTechpack('download')}
              disabled={buttonLoader || productDetails?.isArchived}
            >
              <i className="icon-Download-2" />
            </button>
          </CustomTooltip>
        )}
        {submitDisabled && (
          <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SUBMIT')}>
            <button aria-label="button" className="btn p-0" type="button" onClick={toggleEmailModal} disabled={productDetails?.isArchived}>
              <i className="icon-Submit-and-Download-1" />
            </button>
          </CustomTooltip>
        )}
      </div>
    );
  };

  useEffect(() => {
    const arr = [];
    if (productDetails?.colourLibraries?.length > 0 && ColorWaysLibList?.length > 0) {
      productDetails?.colourLibraries?.forEach((item) => {
        const colour = ColorWaysLibList?.filter((test) => test?._id === item)?.map((k) => k?.name)[0];
        arr.push({ label: colour, name: colour, value: item, _id: item });
      });
      setState((prev) => ({
        ...prev,
        colourwayOptions: arr,
      }));
    }
  }, [ColorWaysLibList, productDetails]);

  const supplierOptionsWithInternal = useMemo(() => [INTERNAL_SUPPLIER_OPTION, ...(supplierList || [])], [supplierList]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <span className="title">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SUBMIT_DOWNLOAD')} </span>
        </div>
        {displayButtons()}
      </div>

      <div className="container submit-container">
        <Row className="mt-16 mb-16">
          <Col md={4} className="">
            <Select
              name="Supplier"
              options={supplierOptionsWithInternal}
              getOptionLabel={({ label }) => `${label}`}
              getOptionValue={({ label }) => `${label}`}
              value={selectedSupplier}
              isDisabled={productDetails?.isArchived}
              styles={customStylesWhiteBordered}
              onChange={(selected) => {
                handleSelectChange(selected, 'selectedSupplier');
              }}
              classNamePrefix="common-select"
              placeholder={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SUPPLIER')}
            />
          </Col>
          <Col md={4} className="">
            <MultiSelect
              name="Colourway"
              options={state.colourwayOptions || []}
              value={state.colourwayOptions?.filter((ele) => state.selectedColourway?.includes(ele?.value)) || null}
              labelledBy={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SELECT_COLOURWAY')}
              styles={customStylesWhiteBordered}
              className="bordered-multiselect common-new-multiselect w-100"
              onChange={(selected) => {
                const selectedColourwayIds = selected.map((val) => val._id);
                handleSelectChange(selectedColourwayIds, 'selectedColourway');
                // Re-fetch POs with colourway filter
                if (selectedSupplier) {
                  fetchPOOptions(selectedColourwayIds);
                }
              }}
              valueRenderer={(selected, _options) => customValueRenderer(selected, _options, 'Colourway')}
            />
          </Col>
          <Col md={4} className="">
            {selectedModules?.length > 0 && selectedModules?.indexOf('qrCode') > -1 && (
              <Select
                name="Factories"
                placeholder={t('PRODUCT_DPP.SELECT_FACTORY')}
                options={factoryOptions || []}
                getOptionLabel={({ label }) => `${label}`}
                getOptionValue={({ value }) => `${value}`}
                value={factoryOptions?.find((ele) => ele?.value === state.selectedFactory?.value) || null}
                // isDisabled={forDisable()}
                styles={customStylesWhiteBordered}
                classNamePrefix="common-select"
                onChange={(selected) => {
                  handleSelectChange(selected, 'selectedFactory');
                }}
              />
            )}
          </Col>
        </Row>
        <div className="common-custom-modal full-width-block mt-3 mb-3">
          <Row>
            {costingAndPurchasing()}
            {technicalPackage()}
            {otherPackage()}
          </Row>
        </div>
      </div>

      {emailModal && (
        <SubmitPopupEmail mainState={state} toggle={toggleEmailModal} handleOnChange={handleSelectChange} downloadSubmitTechpack={downloadSubmitTechpack} />
      )}
    </>
  );
}

export default SubmitDownlod;
